import React from 'react';
import I18n from '@/modules/i18n';
import AIBadge from '@/components/shared/AIBadge';
import { GradientSpinner } from '@/components/ui/Spinner';
import Text from '@/components/ui/Text';
import { IQuestionAnswer } from '@/components/staffer/Grading/types';
import { generatingSuggestionAnswers, pendingSuggestionAnswers } from './aiSuggestion';

const MESSAGE_KEYS = {
  questions: { generating: 'ai_suggestions_generating_questions', review: 'ai_suggestions_questions_to_review' },
  students: { generating: 'ai_suggestions_generating_students', review: 'ai_suggestions_students_to_review' },
};

interface AISuggestionBannerProps {
  questionAnswers?: IQuestionAnswer[];
  unit: keyof typeof MESSAGE_KEYS;
}

const AISuggestionBanner = ({ questionAnswers, unit }: AISuggestionBannerProps) => {
  const generatingCount = generatingSuggestionAnswers(questionAnswers).length;
  const reviewCount = pendingSuggestionAnswers(questionAnswers).length;
  const isGenerating = generatingCount > 0;

  if (!isGenerating && reviewCount === 0) return null;

  const message = isGenerating
    ? I18n.t(MESSAGE_KEYS[unit].generating, { count: generatingCount })
    : I18n.t(MESSAGE_KEYS[unit].review, { count: reviewCount });

  return (
    <div
      className="tw-flex tw-items-center tw-gap-2.5 tw-mt-5 tw-px-2.5 tw-py-3 tw-rounded-lg tw-border tw-border-solid
        tw-border-tci-purple tw-bg-tci-purple/10"
      role="status"
    >
      {isGenerating ? <span className="-tw-m-1 tw-flex"><GradientSpinner size={28} /></span> : <AIBadge />}
      <Text className="tw-text-tci-black" size="sm">{message}</Text>
    </div>
  );
};

export default AISuggestionBanner;
